import * as Yup from "yup";

import type { CatCovered, CatQuote } from "@/api_client";
import type { CatEntryContent } from "@/services/cms/contentTypes/entry/CatEntryContent";
import { getErrorMessageNew } from "@/utils/errorMessage";
import { AgeValidator } from "@/validators/shared/ageValidators";
import { validSSN } from "@/validators/shared/ssnValidator";

export type CatEntryFormType = Pick<
  CatQuote,
  "productType" | "policyHolderSsn" | "catCovered"
>;

const CatCoveredSchema = (
  content?: CatEntryContent | null,
): Yup.ObjectSchema<Pick<CatCovered, "catName" | "catBreed">> =>
  Yup.object({
    catName: Yup.string()
      .required(
        getErrorMessageNew(content?.catName?.ValidationMessages, "required"),
      )
      .max(50, getErrorMessageNew(content?.catName?.ValidationMessages, "max")),
    catBreed: Yup.string().required(
      getErrorMessageNew(content?.catBreed?.ValidationMessages, "required"),
    ),
  });

export const CatEntryValidationSchema = (
  content?: CatEntryContent | null,
): Yup.ObjectSchema<CatEntryFormType> =>
  Yup.object({
    productType: Yup.string().oneOf(["cat"]).required(),
    policyHolderSsn: Yup.string()
      .required(
        getErrorMessageNew(
          content?.policyHolderSsn?.ValidationMessages,
          "required",
        ),
      )
      .test(
        "valid-ssn",
        getErrorMessageNew(
          content?.policyHolderSsn?.ValidationMessages,
          "valid-ssn",
        ),
        validSSN,
      )
      .test(
        "is-18+",
        getErrorMessageNew(
          content?.policyHolderSsn?.ValidationMessages,
          "is-18+",
        ),
        (ssn: string) => {
          const ageValidator = new AgeValidator(ssn);
          return ageValidator.isAtLeast18;
        },
      ),
    catCovered: CatCoveredSchema(content).required(),
  });
